export function initImageSlider() {
	document.querySelectorAll(".bananau-image-slider").forEach((el) => {
		const SVG_NEXT = `<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.4844 10.7744L0.000946045 10.7754" stroke="#705228" stroke-width="0.666667"/>
            <path d="M14.9737 0.235351L25.5137 10.7754L14.9737 21.3153" stroke="#705228" stroke-width="0.666667"/>
        </svg>`;

		const splide = new Splide(el, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			arrows: true,
			pagination: false,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
		});

		splide.on("arrows:mounted", (prev, next) => {
			prev.innerHTML = SVG_NEXT;
			next.innerHTML = SVG_NEXT;
		});

		splide.mount();
	});
}
